var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"tw-flex tw-font-semibold tw-h-20 md:tw-h-10 tw-items-center tw-justify-center bg-blend-color tw--mt-px tw-bg-gradient-to-b md:tw-bg-gradient-to-r",class:[_vm.gradientColourClasses]},[_c('span',{staticClass:"md:tw-px-2 tw-px-5 tw-text-black"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }